module.exports = __webpack_public_path__ + "img/icon-info.4edddce7.svg";